// extracted by mini-css-extract-plugin
export default {"group-contained":"OrdwqY2_MhQjaGbUWRxU"};